import { createContext } from "react";
import { bodyPalette } from "./palettes";
const BodyPaletteContext = createContext(null);
function BodyFinish({
  silhouette,
  children
}) {
  return <BodyPaletteContext.Provider value={bodyPalette(silhouette)}>
      {children}
    </BodyPaletteContext.Provider>;
}
const useBodyPalette = (silhouette) => bodyPalette(silhouette);
export {
  BodyFinish,
  useBodyPalette
};
